export default "__VITE_ASSET__By2m6Cd9__"